import { render } from "./TravelShowcase.vue?vue&type=template&id=101ffc88&scoped=true"
import script from "./TravelShowcase.vue?vue&type=script&lang=js"
export * from "./TravelShowcase.vue?vue&type=script&lang=js"

import "./TravelShowcase.vue?vue&type=style&index=0&id=101ffc88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101ffc88"]])

export default __exports__